/**
*
* Accordion
*
*/


import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';


const StyledAccordion = styled.div`
h1{
  font-size: 14px;
    background: #f0f0f0;
    padding: 10px 20px;
    color: ${({ theme }) => theme.secondaryColor};
}


    .nav {
  max-width: 100%;
  border-radius: 6px;
  background-color: rgba(255, 255, 255, .8);
}
.nav ul {
  list-style: none;
  padding-left: 0;
  margin-bottom: 3px;
}
.nav-item {
    background-color: #F5F6FA;
  }
.nav .nav-item:not(:first-child) {
  border-top: 1px solid BurlyWood;
}

/* primary links */
.nav-link {
  display: block;
  position: relative;
  padding: 14px;
  border: 0;
  color: ${({ theme }) => theme.secondaryColor};
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  text-decoration: none;
 }
.nav-link:focus {
  outline: 0;
  font-weight: bold;
}

/* sub-nav and links */
.sub-nav {
  background: ${({ theme }) => theme.whiteColor};
  padding-left: 20px;
}
.sub-nav a {
  display: block;
  padding: 1rem;
  text-decoration: none;
  color: #555;
}
.sub-nav a:hover,
.sub-nav a:focus {
  text-decoration: underline;
}

/* icon */
.nav-link:not(:only-child)::before,
.nav-link:not(:only-child)::after {
  content: "";
  position: absolute;
  top: 50%; 
  transform: translateY(-50%);
  width: 10px;
  height: 1px;
  background: ${({ theme }) => theme.secondaryColor};
  transition: .25s;
  will-change: transform, bottom, left, right;
}
.nav-link:not(:only-child)::before {
  transform: rotate(-45deg);
  right: 0.9rem;
}
.nav-link:not(:only-child)::after {
  transform: rotate(45deg);
  right: calc(1rem + 5px);
}
/* icon's animation */
.nav-link:not(:only-child):focus::before {
   transform: rotate(45deg) translateZ(0);
 }
.nav-link:not(:only-child):focus::after {
   transform: rotate(-45deg) translateZ(0);
 }

/* hiding / showing sub-nav  */ 
.nav-link + * {
  max-height: 0;
  overflow: hidden;
  transition:  max-height .35s;
}
.nav-link:not(:only-child):focus + * {
  max-height: 200em;
}
.nav-link:not(:only-child):focus {pointer-events:none;}
.nav-link:not(:only-child):not(:focus) { pointer-events:auto }
 
/* Toggle styles */
.toggle-link {
  display: block;
  padding: .5rem .5rem .5rem .5rem;
  border: 1px solid #999;
  margin: 0 0 1rem;
  color: ${({ theme }) => theme.secondaryColor};
  text-decoration: none;
  background-color: #eee;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' version='1.1' width='32' height='24' viewBox='0 0 32 24'><polygon points='0,0 32,0 16,24' style='fill: #333'></polygon></svg>");
  background-size: 9px 6px;
  background-position: right center;
  background-origin: content-box;
  background-repeat: no-repeat;
}
.toggle-link:focus {
 pointer-events:none;
 background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' version='1.1' width='32' height='24' viewBox='0 0 32 24'><polygon points='0,24 16,0 32,24' style='fill: #333;'></polygon></svg>");
}
.toggle-link:not(:focus) {
  pointer-events:auto;
}
.toggle-link + * {
  max-height: 0;
  overflow: hidden;
  transition: max-height 1s;
}
.toggle-link:focus + * {
  max-height: 20em;
}
.toggle-content > * {
  padding: 1rem;
  margin: 0;
  background: rgba(255,255,255,.2);
}
`;
const hellFunc = (description, title) => (
  <li className="nav-item">
    <a className="nav-link" aria-haspopup="true" tabIndex="0" href="#/">{title}</a>
    <div className="sub-nav">
      <div dangerouslySetInnerHTML={{ __html: description }} />
    </div>
  </li>
);

function Accordion(props) {
  const { description, title, header } = props;
  return (
    <StyledAccordion>
      {header && <h1>{header}</h1>}
      <div className="nav" role="navigation">
        <ul>
          {hellFunc(description, title)}
          {/* {props.ary.map((item) => (hellFunc(item.description, item.title)))} */}
        </ul>
      </div>
    </StyledAccordion>
  );
}

Accordion.propTypes = {
  title: PropTypes.string,
  header: PropTypes.string,
  description: PropTypes.string,
};
// Accordion.defaultProps = {
//   ary: [{ description: 'user', title: 'hell' }],
// };

export default Accordion;



// WEBPACK FOOTER //
// client/components/Accordion/index.js